module.exports = __webpack_public_path__ + "img/75994.7b59ea14.svg";